const userTheme = {
  primaryColor: '#7c71ff'
};

const adminTheme = {
  primaryColor: '#d33232'
};

export { userTheme, adminTheme };
